<ejs-dialog target=".dialogs" class="simple-dialog" [visible]='visible' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'40%'" [height]="'60vh'" [zIndex]="999" [showCloseIcon]="true" (close)="close()">
  <ng-template #header>
    <div class="d-flex align-items-center justify-content-center">
      <app-headline [title]="('DOCUMENTSATTACHMENTSTITLE' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
      <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('DOCUMENTSATTACHMENTSHELP' | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
    </div>
  </ng-template>
  <ng-template #content>
    <div class="d-flex flex-column h-100 p-3">
      <app-form-input [placeholder]="('SEARCHFORFILENAMEPLACEHOLDER' | translate)" [iconFront]="'search'" [iconBack]="'close'" [iconClickType]="'back'" (iconBackClick)="resetSearch()" [fCN]="'searchString'" [fG]="documentsAttachmentsForm"></app-form-input>
      @if (filesFiltered.length === 0) {
        <app-headline [title]="('FILENAMECOULDNOTBEFOUNDMESSAGE' | translate)" [type]="'h6'" [class]="'text-center text-secondary'"></app-headline>
      }

      <div class="custom-scrollbar overflow-y-auto">
        <div class="d-flex mb-3 flex-column">
          <div class="fileFolderListContainer d-flex flex-wrap gap-3 p-2">
            @for (file of filesFiltered; track file) {
              <app-item-documents-preview-available [file]="file" [files]="files" [selectable]="false"></app-item-documents-preview-available>
            }
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ejs-dialog>
